export enum TDWorkType {
  'TIES_INSTALLED' = 'TI',
  'SURFACING' = 'SU'
}
